import React from 'react';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import { getLanguage } from 'modules/entity/selectors';
import { LANGUAGES } from 'constants/LanguageConstants';

const requiredMarkStyleByLanguage = {
  [LANGUAGES.JA_JP]: 'font-size-xs'
};

/**
 * @typedef {{
 *  className?: import('classnames').Argument,
 * }} RequiredProps
 */

/** @type {React.FC<RequiredProps>} */
const Required = ({ className }) => {
  const language = useSelector(getLanguage);

  return (
    <b data-cy="required-mark" className={classNames('text-danger mr-1', requiredMarkStyleByLanguage[language], className)}>
      <FormattedMessage id="web.required" defaultMessage="*" />
    </b>
  );
};

export default Required;
